module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<button role="button" data-toggle="popover" data-placement="right"\n        style="background-color: transparent; border-color: transparent">\n    <span class="glyphicon glyphicon-filter" title="Filter"></span>\n</button>\n\n<div id="content" class="form form-horizontal tableDateInput" style="display: none; padding: 3px 3px 3px 3px;">\n    ';
 if (filter.filterType == "interval") { 
__p+='\n    <input type="text" id="from" class="form-control " value="'+
((__t=( filter.from ))==null?'':__t)+
'" placeholder="From"/>\n    <input type="text" id="to" class="form-control " value="'+
((__t=( filter.to ))==null?'':__t)+
'" placeholder="To"/>\n    ';
 } else if (filter.filterType == "select"){ 
__p+='\n    <input id="val"/>\n    ';
 } else { 
__p+='\n    <input type="text" id="val" class="form-control" value="'+
((__t=( filter.value ))==null?'':__t)+
'" placeholder="Value"/>\n    ';
 } 
__p+='\n\n    <label class="checkbox">\n        <input type="checkbox" id="empty-only" class="" ';
 if (filter.onlyEmpty) { 
__p+=' checked ';
 } 
__p+=' /> Empty only\n    </label>\n\n    <span id="apply" class="label label-primary clickable">Apply</span>\n    <span id="reset" class="label label-danger clickable">Reset</span>\n    <span id="cancel" class="label label-warning clickable">Cancel</span>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/common/table-column-filters-view.html
// module id = 290
// module chunks = 0